import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8029ce68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preloaded-video" }

import {computed, onMounted, ref, watch} from 'vue'
  import {useStore} from 'vuex'
  import {getAssetFromStore} from '@/lib/preloader'

  import BufferingNotification from '@/components/BufferingNotification.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PreloadedVideo',
  props: {
    src: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
    src: string
  };

  const store = useStore()

  

  const loading = ref(true)
  const waiting = ref(true)

  const video = ref<HTMLVideoElement>()

  expose({video})

  function getPreloadedVideo() {
    getAssetFromStore({type: 'VIDEO', path: props.src}, store).then((element) => {
      element.currentTime = 0

      if (video.value) {
        loading.value = false

        video.value.setAttribute('src', element.src)
        video.value.addEventListener('canplaythrough', () => {
          video.value.play()
        })

        video.value.addEventListener('waiting', () => {
          waiting.value = true
        })

        video.value.addEventListener('playing', () => {
          waiting.value = false
        })
        try {
          //console.log('playc')
          // video.value.play()
        } catch (e) {
          console.log('error')
        }
      }
    })
  }

  onMounted(() => {
    getPreloadedVideo()
  })

  // todo watch changed videoSource prop

  const globalPaused = computed(() => store.state.paused)

  watch(globalPaused, (value) => {
    if (value) {
      video.value.pause()
    } else {
      video.value.play()
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("video", {
      ref_key: "video",
      ref: video,
      playsInline: "true",
      autoplay: "true",
      disablePictureInPicture: "false"
    }, null, 512),
    _createVNode(BufferingNotification, {
      active: waiting.value || loading.value,
      class: "loading"
    }, null, 8, ["active"])
  ]))
}
}

})